export default {
      id: "compare-usage",
      viewBox: "0 0 27 32",
      url: __webpack_public_path__ + "sprite.svg#compare",
      toString: function () {
        return this.url;
      }
    }